import * as yup from 'yup';

const ProfileElementSchema = yup.object({
  key: yup.string().required('Profile element name is required'),
  type: yup.string().required('Profile type is required'),
  method: yup.string().required('Storage method is required'),
});

export { ProfileElementSchema };
